<template>
  <v-container fluid class="ma-0 pa-2  nextToGo " style="background-color:#232D3F; border-bottom:2px solid #323E53">
    <v-row no-gutters>
      <v-col :cols="$vuetify.breakpoint.xl ? 2.5 : 4" @click="clickNtgRace(race)" v-for="race in nextToGoRaces"
        :key="race.id">
        <v-card width="95%" large class="ma-1 pl-3 pr-2 pt-1 pb-1 ml-0 mt-0 white--text py-xl-2"
          :color="selectedRace.id == race.id ? '#78909c' : '#465169'" elevation="0">
          <div class="d-flex justify-space-between align-center" style="max-height:32px">
            <div class="text-xl-h6 d-flex ">
              <div class="white--text text-xl-h6"
                :style="'max-width: 150px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;'">
                {{ race.meeting.track.name }} </div>
              <div class="ml-1">R{{ race.number }} </div>
            </div>
            <div class="d-flex align-center">
              <MeetingIcon :meeting="race.meeting" class="raceIcon" :inverse="true" />
              <CountryFlags class="d-inline mr-1" :meeting="race.meeting" :small="'normal'" />
            </div>
          </div>

          <LiveCountDown :startTime="race.startTime" style="color:#fff;text-transform: lowercase;" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import LiveCountDown from './LiveCountDown'
import MeetingIcon from './MeetingIcon'
import { getNextToGo } from '../common/methods'
import CountryFlags from '../components/CountryFlags.vue'
// import gql from 'graphql-tag'

export default {
  name: "NextToGo",
  data() {
    return {
      timerNtg: null,
      todayDate: moment().startOf('day').format(),
      tomorrowDate: moment().startOf('day').add(1, 'd').format(),
      thirdDate: moment().startOf('day').add(2, 'd').format(),
    }
  },
  components: {
    LiveCountDown,
    MeetingIcon,
    CountryFlags
  },
  props: {
    meetings: Array,
    races: Array
  },
  // beforeUpdate () {
  //   if (this.signedIn === false) {
  //   this.cancelAutoUpdate();
  //   }
  //   if (!this.timerNtg) {
  //   this.timerNtg = setInterval(this.fetchNtg, 5000)
  //   }
  // },
  // beforeDestroy () {
  //   clearInterval(this.timerNtg)
  // },
  computed: {
    ...mapState(['signedIn']),
    ...mapGetters(['getSelectedRace']),
    selectedRace() {
      return this.getSelectedRace || {}
    },
    nextToGoRaces() {
      return this.$vuetify.breakpoint.xl ? getNextToGo(this.races, 5) : getNextToGo(this.races, 3)
    },
  },
  methods: {
    ...mapActions(['selectMeeting', 'selectRace', 'loadRunners']),
    cancelAutoUpdate() {
      clearInterval(this.timerNtg)
      this.timerNtg = null
    },
    async clickNtgRace(race) {
      this.selectMeeting(race.meeting.id)
      this.selectRace(race.id)
    },
    getNtgFilteredMeetings(filteredNtgRaces) {
      return filteredNtgRaces.filter(race => race.type === 'R' && race.fixedOddsEnabled === true)
    },
    formatDateNtg: function (date) {
      return moment(date, 'YYYY-MM-DD HH:mm').fromNow('ss');
    }
  },
}
</script>

<style scoped>
.raceNameNtg {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 5px;
  font-weight: 600;
}

.nextToGo {
  display: flex;
}

.raceIcon {
  transform: scale(0.7);
  float: right;
}</style>
